import { render } from "./GameView.vue?vue&type=template&id=79a55870"
import script from "./GameView.vue?vue&type=script&lang=js"
export * from "./GameView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matsushitamasaya/webex/setouchi-webapp2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__